export enum AuthErrorOrigin {
    CREATE_AUTH_TOKEN = 'CREATE_AUTH_TOKEN',
    VALIDATE_AUTH_TOKEN = 'VALIDATE_AUTH_TOKEN',
}

export interface AuthError {
    type: AuthErrorOrigin,
    detail: any
}